<template>
    <div id="admin-settings">
        <v-card style="margin-top: 20px" id="datetime-card" class="main_component_card">
            <v-card-title>
                <span class="main_card_title">{{ $i18n.t('pages.security.admin.title') }}</span>
            </v-card-title>
            <v-card-text>
              <div style="margin-bottom: 15px;">
                <v-btn
                    @click="open_roles_list"
                    v-on="on" v-bind="attrs"
                    color="#207ea9"
                    height="42"
                    elevation="0"
                    class="white--text mr-2"
                >
                  <span class="button-font">{{ $i18n.t('pages.security.admin.dialog.roles_editor') }}</span>
                </v-btn>
              </div>
            </v-card-text>
        </v-card>

      <v-dialog v-model="roles_list_dialog" max-width="420px" scrollable>
        <v-card style="border-radius: 8px;" elevation="0">
          <v-card-title style="display: flex; justify-content: space-between">
              <span>{{ $i18n.t('pages.security.admin.dialog.roles_editor') }}</span>
              <v-btn
                class="white--text"
                height="42"
                color="#FFFFFF"
                elevation="0"
                style="padding-left: 10px; padding-right: 10px"
                @click="open_role_editor"
              >
                <span style="color: #207ea9; font-size: 1.05rem; padding-top: 4px" class="button-font">
                  {{ $i18n.t('pages.security.admin.dialog.add_role') }}
                </span>
              </v-btn>
          </v-card-title>
          <v-card-text style="height: 300px;">
              <v-list>
                <template v-for="role in roles">
                  <v-divider :key="role._id['$oid']"></v-divider>
                  <v-list-item :key="role._id['$oid']">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $i18n.t('pages.security.admin.dialog.role') }}: {{role.name}}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div style="display: flex; justify-content: space-around">
                          <v-btn v-if="role.created_by !== 'system'" icon fab color="#207ea9"
                                 small @click="open_role_editor(role)"
                          >
                            <v-icon class="white--text">$icon_edit</v-icon>
                          </v-btn>
                          <v-btn v-if="role.created_by !== 'system'" icon fab color="#207ea9"
                                 small @click="delete_role(role)"
                          >
                            <v-icon class="white--text">$icon_trash</v-icon>
                          </v-btn>
                        </div>
                      </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
          </v-card-text>
          <v-card-actions style="display: flex; justify-content: center; padding: 20px 25px 20px 25px">
            <v-btn
                style="height: 42px;"
                elevation="0"
                width="100%"
                color="#DBEAF1"
                @click="close_roles_list"
            >
              <span style="color: #207EA9;">{{ $i18n.t('general.close') }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="role_edit_dialog" max-width="420px">
        <v-card style="border-radius: 8px" elevation="0">
          <v-card-title>
            <span>{{role_edit_title}}</span>
          </v-card-title>
          <v-card-text style="padding: 0 15px 30px">
            <v-form class="edit_card_container" v-model="role_edit.form_valid" ref="role_edit_form_validation">
              <v-subheader class="subheader">{{ $i18n.t('pages.security.admin.dialog.role_name') }}</v-subheader>
              <v-text-field
                  outlined
                  :placeholder="$i18n.t('pages.security.admin.dialog.role_name')"
                  v-model="edited_role.name"/>
              <v-divider></v-divider>
              <v-virtual-scroll :items="items_with_param_checked" height="300" item-height="50">
                <template v-slot="{ item }">
                  <v-list-item>
                    <v-list-item-title>
                      <v-checkbox style="margin-left: 10px" color="#207EA9" :label="$i18n.t(`side_menu.${item.link}`)" v-model="item.checked"/>
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-form>
            <div style="padding:30px 15px 0 15px; display: flex; justify-content: space-between">
              <v-btn
                  class=" white--text"
                  height="42"
                  color="#DBEAF1"
                  elevation="0"
                  style="width: 170px"
                  @click="close_role_editor"
              >
                <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
              </v-btn>
              <v-btn
                  class="width48 white--text"
                  style="width: 170px"
                  height="42"
                  elevation="0"
                  color="#207ea9"
                  @click="save_role"
              >
                <span class="button-font">{{ $i18n.t('general.save') }}</span>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--
      <v-dialog v-model="password_edit_dialog" max-width="420px">
          <v-card style="border-radius: 8px" elevation="0">
              <v-card-title>
                  <span>{{ $i18n.t('pages.security.admin.dialog.change_admin_password') }}</span>
              </v-card-title>
              <v-card-text style="padding: 0 15px 30px">
                <v-form class="edit_card_container" v-model="password_edit.form_valid" ref="password_form_validation">
                  <v-subheader class="subheader">{{ $i18n.t('pages.security.admin.dialog.old_password') }}</v-subheader>
                  <v-text-field
                    class="rounded_8px height-textfield"
                    outlined
                    :placeholder="$i18n.t('pages.security.admin.dialog.old_password')"
                    :append-icon="show_old_password ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show_old_password = !show_old_password"
                    :type="show_old_password ? 'text' : 'password'"
                    :rules="rules.rules_password"
                    v-model="password_edit.old_password"
                  />
                  <v-subheader class="subheader margin-t">{{ $i18n.t('pages.security.admin.dialog.new_password') }}</v-subheader>
                  <v-text-field
                    class="rounded_8px height-textfield"
                    outlined
                    :placeholder="$i18n.t('pages.security.admin.dialog.new_password')"
                    :append-icon="show_new_password ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show_new_password = !show_new_password"
                    :type="show_new_password ? 'text' : 'password'"
                    :rules="rules.rules_password"
                    v-model="password_edit.new_password"
                  />
                  <v-subheader class="subheader margin-t">{{$i18n.t('pages.security.admin.dialog.new_password_again')}}</v-subheader>
                  <v-text-field
                    outlined
                    class="rounded_8px height-textfield"
                    :placeholder="$i18n.t('pages.security.admin.dialog.new_password_again')"
                    :append-icon="show_new_password_repeated ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show_new_password_repeated = !show_new_password_repeated"
                    :type="show_new_password_repeated ? 'text' : 'password'"
                    :rules="rules.rules_password"
                    v-model="password_edit.new_password_repeated"
                  />
                </v-form>

                <div style="padding:30px 15px 0 15px; display: flex; justify-content: space-between">
                    <v-btn
                      class="white--text"
                      height="42"
                      color="#DBEAF1"
                      elevation="0"
                      style="width: 170px"
                      @click="password_edit_dialog = false"
                    >
                      <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                    </v-btn>
                    <v-btn
                        class="width48 white--text"
                        style="width: 170px"
                        height="42"
                        elevation="0"
                        color="#207ea9"
                        @click="save_password"
                    >
                      <span class="button-font">{{ $i18n.t('general.save') }}</span>
                    </v-btn>
                </div>
              </v-card-text>
          </v-card>
      </v-dialog>
      -->
    </div>
</template>

<script>
import {mapActions} from "vuex";
import {i18n} from "@/i18n";
import {common_funcs} from "@/mixins/common";

export default {
    name: "AdminSettings",
    props: ['on', 'attrs', 'roles', 'users'],
    mixins: [common_funcs],
    data: function () {
        return {
          password_edit_dialog: false,
          roles_list_dialog: false,
          role_edit_dialog: false,

          password_edit: {
            form_valid: true,
            old_password: '',
            new_password: '',
            new_password_repeated: '',
          },
          show_old_password: false,
          show_new_password: false,
          show_new_password_repeated: false,
          rules: {
            rules_username: [
            v => !!v || i18n.t('validation.this_field_is_required'),
            v => v.length >= 5 || i18n.t('validation.username_too_short', {length: 5})
            ],
            rules_password: [
              v => !!v || i18n.t('validation.this_field_is_required'),
              v => v.length >= 5 || i18n.t('validation.password_too_short', {length: 5}),
            ],
          },

          roles_list: {
            form_valid: true,
          },
          role_edit: {
            form_valid: true
          },

          default_role: {name: '', options: [], created_by: 'admin'},
          edited_role: {name: '', options: [], created_by: 'admin'},
          edited_role_index: -1,
        }
    },
    methods: {
        close_password_editor: function () {
          this.password_edit_dialog = false
          this.password_edit.old_password = this.password_edit.new_password = this.password_edit.new_password_repeated = ''
        },
        close_roles_list: function () {
          this.roles_list_dialog = false
        },
        save_password: function () {
          this.password_edit_dialog = false
          if (this.password_edit.new_password !== this.password_edit.new_password_repeated) {
            this.setSnackbar({
              text: i18n.t('notifications.security.passwords_dont_match')
            })
            return
          }
          let data = {old_password: this.password_edit.old_password, new_password: this.password_edit.new_password}
          this.$http({url: this.$http_hostname + '/users/change_admin_password', data: data, method: 'POST'})
          .then(() => {
            this.setSnackbar({
              text: i18n.t('notifications.security.password_changed'),
            })
          })
          .catch(error => {
            this.show_error_message(error)
          })
        },

        open_roles_list: function () {
          this.roles_list_dialog = true
        },

        open_role_editor: function (role) {
            this.edited_role_index = this.roles.indexOf(role)
            Object.assign(this.edited_role, role)
            this.role_edit_dialog = true
        },
        close_role_editor: function () {
          this.edited_role_index = -1
          this.edited_role = Object.assign({}, this.default_role)
          this.role_edit_dialog = false
        },
        save_role: function () {
          let t = this
          this.edited_role.options = this.selected_role_options()
          let _edited_role = this.edited_role
          console.log(this.edited_role)
          let data = {role: this.edited_role}
          if (this.edited_role_index > -1) {
             this.$http({url: this.$http_hostname + '/users/edit_role', data: data, method: 'POST'})
            .then(() => {
              Object.assign(t.roles[t.edited_role_index], _edited_role)
              t.role_edit_dialog = false
            })
            .catch(error => {
              this.show_error_message(error)
            })
          } else {
            this.$http({url: this.$http_hostname + '/users/add_role', data: data, method: 'POST'})
            .then(resp => {
              _edited_role._id = resp.data.new_role_id
              t.roles.push(_edited_role)
              this.role_edit_dialog = false
            })
            .catch(error => {
              this.show_error_message(error)
            })
          }
          // this.role_edit_dialog = false
          // this.close_role_editor()
        },

        delete_role: function (role) {
          let user_with_role = this.users.find(user => user.role_id['$oid'] === role._id['$oid'])
          if (user_with_role) {
            this.setSnackbar({
              text: i18n.t('notifications.security.unable_to_delete_role'),
            })
            return
          }
          let t = this
          let role_index = this.roles.indexOf(role)
          let data = {'role_id': role._id}
          confirm(i18n.t('submissions.delete_role', {role_name: role.name})) &&
          this.$http({url: this.$http_hostname + '/users/delete_role_by_id', data: data, method: 'DELETE'})
          .then(() => {
            t.roles.splice(role_index, 1)
          })
          .catch(error => {
            this.show_error_message(error)
          })

        },
        selected_role_options: function () {
          return this.items_with_param_checked.filter(item => item.checked).map(item => item.link)
        },
        ...mapActions(['setSnackbar'])
    },
  computed: {
    role_edit_title: function () {
      let text_add_role = i18n.t('pages.security.admin.dialog.add_role')
      let text_edit_role = i18n.t('pages.security.admin.dialog.edit_role')
      return this.edited_role_index === -1 ? text_add_role : text_edit_role
    },
    items_with_param_checked: function () {
      return this.$store.state.menu_items.map(item => {
        item.checked = this.edited_role.options.includes(item.link);
        return item
      })
    },
  },
  watch: {
    password_edit_dialog (val) {
      this.$refs.password_form_validation.resetValidation()
      !val && this.close_password_editor()
    },
    role_edit_dialog (val) {
      this.$refs.role_edit_form_validation.resetValidation()
      !val && this.close_role_editor()
    }
  }
}
</script>

<style scoped>
#datetime-card {
  background: #FFFFFF;
  box-shadow: 0px 3px 2px rgba(138, 138, 138, 0.15);
  border-radius: 8px;
}
.height-textfield {
  height: 56px;
}
</style>